import { render, staticRenderFns } from "./DirectoriosContent.vue?vue&type=template&id=7724b7a3&"
import script from "./DirectoriosContent.vue?vue&type=script&lang=js&"
export * from "./DirectoriosContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports